import { motion } from "framer-motion";

export const Reveal = ({
  children,
  delay = 0,
  y = 36,
  className = "",
  once = true,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`uppercase text-xs sm:text-sm tracking-[0.28em] font-semibold ${
      light ? "text-brand-goldlight" : "text-brand-green"
    }`}
  >
    {children}
  </p>
);
